import { FunctionComponent } from 'react'
import styled, { css, useTheme } from 'styled-components'
import { SvgIconProps } from '@components/SvgIcon'

import SvgIcon from '../../../SvgIcon'

import {
  desktopCSS,
  tabletCSS,
  mobileCSS,
  landscapeOrientationCSS,
} from '@measures/responsive'

export interface ButtonIconProps {
  iconName: SvgIconProps['iconName']
  smallSize?: boolean
  isOverlay?: boolean
}

const StyledButtonIcon = styled(SvgIcon)<
  Pick<ButtonIconProps, 'isOverlay' | 'smallSize'>
>`
  ${({ isOverlay, smallSize }) => {
    // desktop inline and fullscreen: 96x96px
    // desktop 66% (smallSize): 64x64px
    // mobile landscape fullscreen(overlay): 64x64px
    // mobile inline & portrait: 48x48px
    return css`
      ${desktopCSS(css`
        width: 96px;
        height: 96px;

        ${smallSize &&
        css`
          width: 64px;
          height: 64px;
        `}
      `)}

      ${tabletCSS(css`
        width: 64px;
        height: 64px;
      `)}

      ${mobileCSS(css`
        width: 48px;
        height: 48px;

        ${isOverlay &&
        landscapeOrientationCSS(css`
          width: 64px;
          height: 64px;
        `)}
      `)}
    `
  }}
`

const ButtonIcon: FunctionComponent<ButtonIconProps> = ({
  smallSize,
  isOverlay,
  iconName,
}) => {
  const theme = useTheme()

  return (
    <StyledButtonIcon
      iconName={iconName}
      size={96}
      color={theme.colors.white}
      isOverlay={isOverlay}
      smallSize={smallSize}
    />
  )
}

export default ButtonIcon
